import React from 'react';
import PropTypes from 'prop-types';

import { Button, Row, Col } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

import { backgroundGrey1, greyStroke } from 'lib/css/colors';
import NameSearchFilter from 'components/manage_manufacturers/global_manufacturer_harvest/NameSearchFilter';
import TagFilter from 'components/manage_manufacturers/global_manufacturer_harvest/TagFilter.jsx';

function FilterBar({
  selectedTags,
  onTagsChange,
  searchName,
  onSearchNameChange,
  onClearFilters,
  hasActiveFilters,
}) {
  return (
    <div className={css(styles.container)}>
      <Row className="align-items-end">
        <Col md={6} lg={4}>
          <NameSearchFilter value={searchName} onChange={onSearchNameChange} />
        </Col>
        <Col md={6} lg={4}>
          <TagFilter selectedTags={selectedTags} onChange={onTagsChange} />
        </Col>
        <Col md={12} lg={4} className="d-flex align-items-end">
          {hasActiveFilters && (
            <Button variant="outline-secondary" size="sm" onClick={onClearFilters}>
              Clear Filters
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: '16px 20px',
    backgroundColor: backgroundGrey1,
    borderRadius: 8,
    marginBottom: 20,
    border: `1px solid ${greyStroke}`,
  },
});

FilterBar.propTypes = {
  selectedTags: PropTypes.arrayOf(PropTypes.object),
  onTagsChange: PropTypes.func.isRequired,
  searchName: PropTypes.string,
  onSearchNameChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
};

FilterBar.defaultProps = {
  selectedTags: [],
  searchName: '',
};

export default FilterBar;
